import { render, staticRenderFns } from "./MonitoringWaitingPatients.vue?vue&type=template&id=d9e6d00a&scoped=true&"
import script from "./MonitoringWaitingPatients.vue?vue&type=script&lang=js&"
export * from "./MonitoringWaitingPatients.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringWaitingPatients.vue?vue&type=style&index=0&id=d9e6d00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e6d00a",
  null
  
)

export default component.exports